import angular from 'angular';
import categoryGraph from './categoryGraph';
import directive from './category.directive';
import controller from './category.controller';


export default angular.module('app.components.advisory.ecat.category', [
  categoryGraph
])
  .directive('ecatCategory', directive)
  .controller('ECATCategoryController', controller)
  .name;

console.log('app.components.advisory.ecat.category created');
